module.exports = __webpack_public_path__ + "img/onetit.665d2c9f.png";